/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CategoryType {
  DIGITAL = "DIGITAL",
  PHYSICAL = "PHYSICAL",
}

export enum ChannelType {
  sms = "sms",
  whatsapp = "whatsapp",
}

export enum Condition {
  and = "and",
  or = "or",
}

export enum CountryCode {
  GH = "GH",
  NG = "NG",
  ZA = "ZA",
}

export enum CurrencyCode {
  GHS = "GHS",
  NGN = "NGN",
  ZAR = "ZAR",
}

export enum DeliveryAgent {
  SHOP = "SHOP",
  TENDO = "TENDO",
}

export enum DeliveryOption {
  Manual = "Manual",
  Swoove = "Swoove",
}

export enum DiscountType {
  FIXED_AMOUNT = "FIXED_AMOUNT",
  FREE_DELIVERY = "FREE_DELIVERY",
  PERCENTAGE = "PERCENTAGE",
}

export enum FixedAmountAllocation {
  PRODUCT_SPECIFIC = "PRODUCT_SPECIFIC",
  TOTAL_AMOUNT = "TOTAL_AMOUNT",
}

export enum InboxEventAction {
  ATTENDED = "ATTENDED",
  OPENED = "OPENED",
  UPDATED = "UPDATED",
}

export enum InboxKind {
  FAILED_ORDER_CHARGE = "FAILED_ORDER_CHARGE",
  ORDER_CREATED = "ORDER_CREATED",
  ORDER_STATUS_CHANGED = "ORDER_STATUS_CHANGED",
  STOCK_UPDATED = "STOCK_UPDATED",
  WALLET_PAYOUT_PENDING = "WALLET_PAYOUT_PENDING",
}

export enum InboxStatus {
  ATTENDED = "ATTENDED",
  OPEN = "OPEN",
}

export enum InboxSubjectType {
  failed_order_charge = "failed_order_charge",
  order = "order",
  order_item = "order_item",
  product = "product",
  wallet_payout = "wallet_payout",
}

export enum LockStatus {
  frozen = "frozen",
  limited = "limited",
  open = "open",
}

export enum PartnershipStatus {
  Approved = "Approved",
  Pending = "Pending",
  Rejected = "Rejected",
}

export enum PaymentOption {
  Cash = "Cash",
  Online = "Online",
}

export enum PaystackGhanaBankType {
  ghipps = "ghipps",
  mobile_money = "mobile_money",
}

export enum PaystackMobileMoneyProvider {
  atl = "atl",
  mtn = "mtn",
  vod = "vod",
}

export enum ProductCondition {
  IN = "IN",
  NOT_IN = "NOT_IN",
}

export enum ProductDistinctField {
  attended_to = "attended_to",
  avatar = "avatar",
  combination_string = "combination_string",
  cost_price = "cost_price",
  country = "country",
  created_at = "created_at",
  currency = "currency",
  description = "description",
  id = "id",
  inhouse = "inhouse",
  limited_stock = "limited_stock",
  price = "price",
  published = "published",
  qty = "qty",
  shop_id = "shop_id",
  sku = "sku",
  title = "title",
  updated_at = "updated_at",
  uuid = "uuid",
  verified = "verified",
  weight = "weight",
}

export enum ProductOrigin {
  IN_HOUSE = "IN_HOUSE",
  MAGENTO = "MAGENTO",
  SHOPIFY = "SHOPIFY",
  SUPPLIER_OFFLINE_CATALOGUE = "SUPPLIER_OFFLINE_CATALOGUE",
  SUPPLIER_TENDO_ONLINE_CATALOGUE = "SUPPLIER_TENDO_ONLINE_CATALOGUE",
  WOOCOMMENCE = "WOOCOMMENCE",
}

export enum ProductStatus {
  ACCEPTED = "ACCEPTED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export enum ProductType {
  Digital = "Digital",
  Physical = "Physical",
}

export enum ReasonForPayment {
  order_purchase = "order_purchase",
  wallet_topup = "wallet_topup",
}

export enum Settlement {
  Commission = "Commission",
  Markup = "Markup",
}

export enum ShopType {
  reseller = "reseller",
  supplier = "supplier",
}

export enum SortOrder {
  ascending = "ascending",
  descending = "descending",
}

export enum SupplierType {
  ADVANCED = "ADVANCED",
  BASIC = "BASIC",
}

export enum TemplateType {
  ALERT = "ALERT",
  CHECKBOX = "CHECKBOX",
  DATE = "DATE",
  EMAIL = "EMAIL",
  FILE = "FILE",
  NUMBER = "NUMBER",
  PASSWORD = "PASSWORD",
  RADIO = "RADIO",
  RICHTEXT = "RICHTEXT",
  SELECT = "SELECT",
  TEXT = "TEXT",
  TEXTAREA = "TEXTAREA",
}

export enum TransactionDirection {
  inbound = "inbound",
  outbound = "outbound",
}

export enum TransactionStatus {
  failed = "failed",
  pending = "pending",
  success = "success",
}

export enum TransactionType {
  charge = "charge",
  conversion = "conversion",
  deposit = "deposit",
  order_purchase = "order_purchase",
  profit_payout = "profit_payout",
  refund = "refund",
  supplier_payment = "supplier_payment",
  transfer = "transfer",
  withdrawal = "withdrawal",
}

export enum UserAccountType {
  CUSTOMER = "CUSTOMER",
  DEVELOPER = "DEVELOPER",
  MANAGER = "MANAGER",
  MERCHANT = "MERCHANT",
  RESELLER = "RESELLER",
  SUPPLIER = "SUPPLIER",
}

export enum UserType {
  DEVELOPER = "DEVELOPER",
  IN_HOUSE = "IN_HOUSE",
  RESELLER = "RESELLER",
  SUPPLIER = "SUPPLIER",
}

export enum WalletPayoutStatus {
  approved = "approved",
  declined = "declined",
  pending = "pending",
}

export enum WalletType {
  house = "house",
  house_profit = "house_profit",
  merchant = "merchant",
  payment_facilitator = "payment_facilitator",
  supplier = "supplier",
}

export enum distributionChannel {
  MarketPlace = "MarketPlace",
  ResellerNetwork = "ResellerNetwork",
  SupplierStorefront = "SupplierStorefront",
  TendoNetwork = "TendoNetwork",
}

export interface ActivateShopRequestDto {
  userId: string;
  shopType: ShopType;
}

export interface AddPluginToUserRequestDto {
  plugin_id: string;
  user_id: string;
}

export interface AddressInput {
  id?: string | null;
  country?: string | null;
  city?: string | null;
  area: string;
  lat?: string | null;
  lng?: string | null;
  landmark?: string | null;
}

export interface BooleanOperator {
  eq?: boolean | null;
}

export interface BulkProductStockInput {
  sku: string;
  qty: number;
  cost_price: number;
  price: number;
  personnel?: string | null;
  reason?: string | null;
}

export interface CartFilter {
  id?: IdOperator | null;
  user_id?: IdOperator | null;
  customer_id?: IdOperator | null;
  supplier_id?: IdOperator | null;
  source?: StringOperator | null;
  status?: StringOperator | null;
  shop_id?: IdOperator | null;
  supplier_status?: StringOperator | null;
  country?: StringOperator | null;
  cart_number?: StringOperator | null;
  payment_id?: StringOperator | null;
  offline?: BooleanOperator | null;
  user_type?: StringOperator | null;
  tracking_code?: StringOperator | null;
  instantDelivery?: BooleanOperator | null;
}

export interface CatalogFilter {
  id?: IdOperator | null;
  name?: StringOperator | null;
  country?: StringOperator | null;
}

export interface CountryCodeOperator {
  eq?: CountryCode | null;
  in?: CountryCode[] | null;
  notIn?: CountryCode[] | null;
}

export interface CreateDiscountRequestDto {
  type: DiscountType;
  valid_country: string;
  code?: string | null;
  percentage?: number | null;
  amount?: number | null;
  description: string;
  is_draft: boolean;
  start_date: string;
  expiry_date: string;
  redemptions_limit?: number | null;
  product_condition?: ProductCondition | null;
  products?: string[] | null;
  fixed_amount_allocation?: FixedAmountAllocation | null;
  created_by?: UserType | null;
  user_id?: string | null;
  banner_url: string;
  locations?: (string | null)[] | null;
  locations_tagname?: string | null;
}

export interface CurrencyInput {
  code: string;
  name: string;
}

export interface CustomerFilter {
  id?: IdOperator | null;
  user_id?: IdOperator | null;
  supplier_id?: IdOperator | null;
  name?: StringOperator | null;
  email?: StringOperator | null;
  address?: StringOperator | null;
  phone?: StringOperator | null;
}

export interface CustomerInput {
  id?: string | null;
  name: string;
  email?: string | null;
  phone: string;
  address?: AddressInput | null;
}

export interface DateOperator {
  eq?: any | null;
  before?: any | null;
  after?: any | null;
  between?: DateRange | null;
}

export interface DateRange {
  start: any;
  end: any;
}

export interface DeliveryFilter {
  id?: StringOperator | null;
  supplierId?: IdOperator | null;
  location?: StringOperator | null;
  price?: NumberOperator | null;
  remarks?: StringOperator | null;
  isPayOnline?: BooleanOperator | null;
  hasInstantDelivery?: BooleanOperator | null;
  country?: StringOperator | null;
}

export interface Details {
  user_id?: string | null;
  dob?: any | null;
  gender?: string | null;
  referred_by?: string | null;
}

export interface DiscountFilter {
  id?: IdOperator | null;
  type?: StringOperator | null;
  valid_country?: StringOperator | null;
  code?: StringOperator | null;
  percentage?: NumberOperator | null;
  amount?: NumberOperator | null;
  description?: StringOperator | null;
  is_draft?: BooleanOperator | null;
  start_date?: DateOperator | null;
  expiry_date?: DateOperator | null;
  redemptions_limit?: NumberOperator | null;
  fixed_amount_allocation?: StringOperator | null;
  created_at?: DateOperator | null;
  updated_at?: DateOperator | null;
  created_by?: StringOperator | null;
  user_id?: IdOperator | null;
  number_of_times_used?: NumberOperator | null;
  locations?: StringOperator | null;
}

export interface DiscountProductConditionFilter {
  id?: IdOperator | null;
  product_sku?: StringOperator | null;
  condition?: StringOperator | null;
  discount_id?: IdOperator | null;
  created_at?: DateOperator | null;
  updated_at?: DateOperator | null;
}

export interface FeaturedCategoriesFilter {
  id?: IdOperator | null;
  country?: StringOperator | null;
}

export interface FetchShopifyShopInput {
  filter?: ShopifyShopFilter | null;
  condition?: Condition | null;
}

export interface GetStorefrontTransactionsInput {
  filter: StorefrontTransactionFilter;
  pagination?: Pagination | null;
  condition?: Condition | null;
  sort?: SortOrder | null;
}

export interface GetSupportedProvidersInput {
  country: CountryCode;
  filter?: PaystackBanksFilter | null;
}

export interface GetTransactionsInput {
  filter: TransactionFilter;
  pagination?: Pagination | null;
  condition?: Condition | null;
  sort?: SortOrder | null;
}

export interface GetWalletPayoutsInput {
  filter?: WalletPayoutFilter | null;
  pagination?: Pagination | null;
  sort?: SortOrder | null;
  condition?: Condition | null;
}

export interface IdOperator {
  eq?: string | null;
  in?: string[] | null;
  notIn?: string[] | null;
}

export interface InboxFilter {
  status?: InboxStatus | null;
  kind?: InboxKind | null;
}

export interface InitiateCardSetupInput {
  integration_id: string;
  supplier_email: string;
  supplier_phone: string;
}

export interface LoadProductToShopify {
  uuid: string;
  qty: number;
  title: string;
  description: string;
  price?: number | null;
  sku: string;
  media: string[];
  tags?: (string | null)[] | null;
  supplier_generic_name?: string | null;
  product_origin: ProductOrigin;
  product_id: string;
  combination_string?: string | null;
}

export interface LoadProductToShopifyInput {
  products?: LoadProductToShopify[] | null;
  integration_id?: string | null;
}

export interface MakePaymentInput {
  wallet_id?: string | null;
  amount: number;
  currency: CurrencyInput;
  phone: string;
  email: string;
  reason_for_payment: ReasonForPayment;
  description?: string | null;
  secret: string;
  provider?: PaystackMobileMoneyProvider | null;
}

export interface NumberOperator {
  eq?: number | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  between?: (number | null)[] | null;
}

export interface OrderCreateInput {
  id?: string | null;
  customer_id: string;
  supplier_id?: string | null;
  address_id?: string | null;
  total_amount: number;
  discount: number;
  delivery_amount: number;
  shipping_cost?: number | null;
  customer_paid: boolean;
  security_deposit?: number | null;
  free_delivery?: boolean | null;
  payment_type?: string | null;
  delivery_type?: string | null;
  reseller: string;
  products: OrderProductInput[];
  status?: string | null;
  supplier_status?: string | null;
  couponCode?: string | null;
  delivery_id?: string | null;
  estimate_id?: string | null;
  payment_status?: string | null;
  payment_id?: string | null;
  hasPreviousOrder?: boolean | null;
  source?: string | null;
  instantDelivery?: boolean | null;
  coupon_id?: string | null;
  shop_id?: string | null;
}

export interface OrderFilter {
  id?: IdOperator | null;
  productId?: IdOperator | null;
  sku?: IdOperator | null;
  orderId?: IdOperator | null;
  cart_number?: StringOperator | null;
  status?: StringOperator | null;
  supplier_status?: StringOperator | null;
  orderNumber?: StringOperator | null;
  source?: StringOperator | null;
  country?: StringOperator | null;
  tracking_code?: StringOperator | null;
  user_id?: IdOperator | null;
  payment_id?: StringOperator | null;
  supplier_id?: IdOperator | null;
  offline?: BooleanOperator | null;
  user_type?: StringOperator | null;
  customer_id?: IdOperator | null;
  instantDelivery?: BooleanOperator | null;
}

export interface OrderProductInput {
  product_id: string;
  qty: number;
  profitAdded: number;
  price: number;
  cost_price?: number | null;
  discount?: number | null;
}

export interface Pagination {
  offset?: number | null;
  limit?: number | null;
}

export interface PartnershipFilter {
  id?: IdOperator | null;
  supplier_id?: IdOperator | null;
  client_id?: IdOperator | null;
  status?: PartnershipStatus | null;
}

export interface PaystackBanksFilter {
  country?: string | null;
  type?: PaystackGhanaBankType | null;
  use_cursor?: boolean | null;
  perPage?: number | null;
  next?: string | null;
  previous?: string | null;
  gateway?: string | null;
}

export interface PaystackValidateAccountInput {
  account_number: string;
  bank_code: string;
  account_name?: string | null;
  account_type?: string | null;
  country?: string | null;
  document_type?: string | null;
  document_number?: string | null;
}

export interface PluginFilter {
  id?: IdOperator | null;
  name?: StringOperator | null;
  logo?: StringOperator | null;
  banner_image?: StringOperator | null;
  category?: StringOperator | null;
  developer?: StringOperator | null;
  verified?: BooleanOperator | null;
  description?: StringOperator | null;
  endpoint?: StringOperator | null;
  created_at?: DateOperator | null;
  updated_at?: DateOperator | null;
}

export interface ProductCategoryAndTagsInput {
  product_id: string;
  categories?: string[] | null;
  tags?: string[] | null;
  published?: boolean | null;
  status?: ProductStatus | null;
  verified?: boolean | null;
  personnel?: string | null;
  reason?: string | null;
}

export interface ProductCategoryFilter {
  id?: IdOperator | null;
  shop_id?: IdOperator | null;
  supplier_id?: IdOperator | null;
  name?: StringOperator | null;
  type?: StringOperator | null;
  description?: StringOperator | null;
  country?: StringOperator | null;
  parent?: NumberOperator | null;
  random?: boolean | null;
}

export interface ProductCombinationInput {
  id?: string | null;
  sku: string;
  price: number;
  qty: number;
  cost_price: number;
  combination_string: string;
  avatar: string;
  media?: string[] | null;
  categories?: (string | null)[] | null;
}

export interface ProductHistoryFilter {
  product_id?: IdOperator | null;
  action?: StringOperator | null;
}

export interface ProductInformationInput {
  product_id: string;
  title?: string | null;
  price?: number | null;
  cost_price?: number | null;
  supplier_cost?: number | null;
  description?: string | null;
  sku: string;
  currency?: CurrencyCode | null;
  country?: CountryCode | null;
  weight?: number | null;
  minimumOrderQuantity?: number | null;
  maximumDeliveryTime?: number | null;
  minimumDeliveryTime?: number | null;
  extra_information?: string | null;
  published?: boolean | null;
  status?: ProductStatus | null;
  verified?: boolean | null;
  personnel?: string | null;
  reason?: string | null;
}

export interface ProductInventoryInput {
  product_id: string;
  limited_stock?: boolean | null;
  qty?: number | null;
  price?: number | null;
  cost_price?: number | null;
  published?: boolean | null;
  status?: ProductStatus | null;
  verified?: boolean | null;
  personnel?: string | null;
  reason?: string | null;
}

export interface ProductMediaInput {
  product_id: string;
  media?: string[] | null;
  avatar?: string | null;
  published?: boolean | null;
  verified?: boolean | null;
  status?: ProductStatus | null;
  personnel?: string | null;
  reason?: string | null;
}

export interface ProductSort {
  field: ProductDistinctField;
  order: SortOrder;
}

export interface ShopCollectionProductFilter {
  collection_id?: IdOperator | null;
}

export interface ShopFilter {
  id?: IdOperator | null;
  name?: StringOperator | null;
  description?: StringOperator | null;
  contactEmail?: StringOperator | null;
  email?: StringOperator | null;
  currency?: StringOperator | null;
  slug?: StringOperator | null;
  primaryDomain?: StringOperator | null;
  sokoWorldDomain?: StringOperator | null;
  hasBeenSetup?: BooleanOperator | null;
  isActive?: BooleanOperator | null;
  createdAt?: DateOperator | null;
  updatedAt?: DateOperator | null;
  avatar?: StringOperator | null;
  country?: StringOperator | null;
  coverImage?: StringOperator | null;
  deliveryOption?: StringOperator | null;
  deliveryAgent?: StringOperator | null;
  url?: StringOperator | null;
  shortUrl?: StringOperator | null;
  phone?: StringOperator | null;
  ownerId?: StringOperator | null;
  shopType?: StringOperator | null;
}

export interface ShopLocationRequestDto {
  lat: number;
  long: number;
}

export interface ShopProductFilter {
  shop_id?: IdOperator | null;
}

export interface ShopifyShopFilter {
  id?: IdOperator | null;
  shop?: StringOperator | null;
  supplier_id?: IdOperator | null;
}

export interface StorefrontTransactionFilter {
  id?: IdOperator | null;
  reference?: StringOperator | null;
  currency?: StringOperator | null;
  type?: TransactionTypeOperator | null;
  created_at?: DateOperator | null;
}

export interface StringOperator {
  eq?: string | null;
  notEq?: string | null;
  like?: string | null;
  notContains?: string | null;
  in?: string[] | null;
  notIn?: string[] | null;
  regex?: string | null;
}

export interface StripeAccountSessionInput {
  supplier_id?: string | null;
  email?: string | null;
  country?: string | null;
  business_data?: string | null;
}

export interface SupplierAddDeviceTokenInput {
  id: string;
  deviceToken: string;
}

export interface SupplierBusinessInput {
  id?: string | null;
  supplier_id: string;
  business_name: string;
  industry: string;
  description?: string | null;
  logo?: string | null;
  registered: boolean;
  email: string;
  phone: string;
  city: string;
  state?: string | null;
  postal_code?: string | null;
  delivery_option?: string | null;
  business_address?: string | null;
  country?: string | null;
  referred_by?: string | null;
}

export interface SupplierEmailChangeInput {
  id: string;
  newEmail: string;
}

export interface SupplierFilter {
  id?: IdOperator | null;
  name?: StringOperator | null;
  email?: StringOperator | null;
  phone?: StringOperator | null;
  country?: StringOperator | null;
  supplier_type?: SupplierType | null;
  has_accepted_terms?: BooleanOperator | null;
}

export interface SupplierInput {
  id?: string | null;
  name: string;
  email: string;
  phone: string;
  country: string;
  password?: string | null;
  supplier_type?: SupplierType | null;
  onboardingType?: string | null;
}

export interface SupplierPasswordChangeInput {
  id: string;
  newPassword: string;
  oldPassword: string;
}

export interface SupplierPasswordResetInput {
  token: string;
  password: string;
}

export interface SupplierProductFilter {
  sku?: StringOperator | null;
  combination_string?: StringOperator | null;
  distributionChannels?: StringOperator | null;
  title?: StringOperator | null;
  price?: NumberOperator | null;
  id?: IdOperator | null;
  qty?: NumberOperator | null;
  transit_stock?: NumberOperator | null;
  main_stock?: NumberOperator | null;
  supplier_id?: IdOperator | null;
  reseller_id?: IdOperator | null;
  partner?: IdOperator | null;
  contractor?: IdOperator | null;
  verified?: BooleanOperator | null;
  published?: BooleanOperator | null;
  status?: StringOperator | null;
  category?: ProductCategoryFilter | null;
  country?: StringOperator | null;
  tags?: StringOperator | null;
  resell?: BooleanOperator | null;
  product_origin?: StringOperator | null;
  productType?: ProductType | null;
}

export interface SyncShopifyProductInput {
  product_ids?: string[] | null;
  integration_id: string;
  distributionChannel?: (distributionChannel | null)[] | null;
  supplier_country: string;
}

export interface TempCategoryInput {
  name: string;
  description?: string | null;
}

export interface TemplateFilter {
  name?: StringOperator | null;
  id?: IdOperator | null;
}

export interface TermInput {
  id?: string | null;
  name: string;
  description?: string | null;
  settlementType: Settlement;
  settlementValue: number;
  settlementCurrency?: string | null;
  settlementPeriod?: number | null;
  returnPeriod?: number | null;
  returnPolicy?: string | null;
  shippingPolicy?: string | null;
  cancellationPolicy?: string | null;
  shipTo?: string | null;
  ShippingLocations?: (string | null)[] | null;
  estimatedDeliveryTime?: number | null;
  estimatedDeliveryTimeUnit?: string | null;
  supplier_id: string;
}

export interface TermsFilter {
  id?: IdOperator | null;
  name?: StringOperator | null;
  description?: StringOperator | null;
  settlementType?: Settlement | null;
  settlementCurrency?: StringOperator | null;
  settlementPeriod?: NumberOperator | null;
  returnPeriod?: NumberOperator | null;
  supplier_id?: IdOperator | null;
  shipTo?: StringOperator | null;
  estimatedDeliveryTime?: NumberOperator | null;
}

export interface TransactionDirectionOperator {
  eq?: TransactionDirection | null;
  in?: TransactionDirection[] | null;
  notIn?: TransactionDirection[] | null;
}

export interface TransactionFilter {
  merchant_id?: IdOperator | null;
  id?: IdOperator | null;
  wallet_id?: IdOperator | null;
  wallet_type?: WalletTypeOperator | null;
  reference?: StringOperator | null;
  currency?: StringOperator | null;
  type?: TransactionTypeOperator | null;
  direction?: TransactionDirectionOperator | null;
  created_at?: DateOperator | null;
}

export interface TransactionTypeOperator {
  eq?: TransactionType | null;
  in?: TransactionType[] | null;
  notIn?: TransactionType[] | null;
}

export interface UpdateDiscountData {
  type?: DiscountType | null;
  valid_country?: string | null;
  code?: string | null;
  percentage?: number | null;
  amount?: number | null;
  description?: string | null;
  is_draft?: boolean | null;
  start_date?: string | null;
  expiry_date?: string | null;
  redemptions_limit?: number | null;
  fixed_amount_allocation?: FixedAmountAllocation | null;
  created_by?: UserType | null;
  user_id?: string | null;
  locations?: (string | null)[] | null;
}

export interface UpdateProductDistributionInput {
  product_id: string;
  distributionChannels: string[];
  price?: number | null;
  cost_price?: number | null;
  supplier_cost?: number | null;
  published?: boolean | null;
  verified?: boolean | null;
  status?: ProductStatus | null;
  personnel?: string | null;
  reason?: string | null;
}

export interface UpdateShopDetailsRequestDto {
  shopId: string;
  shopType: ShopType;
  name?: string | null;
  description?: string | null;
  contactEmail?: string | null;
  email?: string | null;
  currency?: CurrencyCode | null;
  primaryDomain?: string | null;
  sokoWorldDomain?: string | null;
  customDomains?: (string | null)[] | null;
  shopTags?: (string | null)[] | null;
  avatar?: string | null;
  country?: CountryCode | null;
  coverImage?: string | null;
  deliveryOption?: DeliveryOption | null;
  deliveryAgent?: DeliveryAgent | null;
  location?: ShopLocationRequestDto | null;
  paymentOptions?: (PaymentOption | null)[] | null;
  phone?: string | null;
}

export interface UpdateSupplierDetailsData {
  name?: string | null;
  avatar?: string | null;
}

export interface UpdateSupplierDetailsInput {
  id?: string | null;
  data?: UpdateSupplierDetailsData | null;
}

export interface UpdateSupplierPaymentInput {
  supplier_id: string;
  input: UpdateSupplierPaymentInputOptions;
}

export interface UpdateSupplierPaymentInputOptions {
  method: string;
  account_number: string;
  provider: string;
  account_name: string;
  stripe_account_id?: string | null;
}

export interface UpdateSupplierSlugInput {
  supplier_id: string;
  slug: string;
}

export interface UserFilter {
  id?: IdOperator | null;
  email?: StringOperator | null;
  referred_by?: StringOperator | null;
  supplier_id?: IdOperator | null;
  name?: StringOperator | null;
  phone?: StringOperator | null;
  country?: StringOperator | null;
  state?: StringOperator | null;
  verified?: BooleanOperator | null;
  user_type?: StringOperator | null;
  username?: StringOperator | null;
}

export interface UserPluginFilter {
  id?: IdOperator | null;
  user_id?: IdOperator | null;
  plugin_id?: IdOperator | null;
}

export interface VariationInput {
  id?: string | null;
  variation_name: string;
  variation_options?: (VariationOptionInput | null)[] | null;
}

export interface VariationOptionInput {
  id?: string | null;
  variation_value?: string | null;
}

export interface WalletPayoutFilter {
  id?: IdOperator | null;
  transaction_id?: IdOperator | null;
  wallet_id?: IdOperator | null;
  merchant_id?: IdOperator | null;
  wallet_type?: WalletTypeOperator | null;
  status?: WalletPayoutStatusOperator | null;
  currency?: StringOperator | null;
  country?: CountryCodeOperator | null;
  created_at?: DateOperator | null;
}

export interface WalletPayoutStatusOperator {
  eq?: WalletPayoutStatus | null;
  in?: WalletPayoutStatus[] | null;
  notIn?: WalletPayoutStatus[] | null;
}

export interface WalletTypeOperator {
  eq?: WalletType | null;
}

export interface WalletWithdrawalInput {
  wallet_id: string;
  amount: number;
  currency: CurrencyInput;
  description?: string | null;
  provider?: WithdrawalProviderInput | null;
  secret: string;
  metadata?: any | null;
}

export interface WithdrawalProviderInput {
  account_number: string;
  account_name: string;
  name: string;
}

export interface accountRegisterInput {
  name: string;
  email: string;
  password: string;
  country: string;
  state?: string | null;
  phone: string;
  details?: Details | null;
  social_login?: boolean | null;
  referred_by?: string | null;
  supplier_shop_id?: string | null;
}

export interface addSupplierPaymentInput {
  id?: string | null;
  supplier_id: string;
  account_name: string;
  account_number: string;
  provider: string;
  method: string;
  stripe_account_id?: string | null;
}

export interface createProductInput {
  id?: string | null;
  title: string;
  sku: string;
  qty?: number | null;
  minimumDeliveryTime?: number | null;
  maximumDeliveryTime?: number | null;
  shippingCost?: number | null;
  description: string;
  limited_stock?: boolean | null;
  inhouse?: boolean | null;
  currency: CurrencyCode;
  country: CountryCode;
  published: boolean;
  status?: ProductStatus | null;
  price: number;
  supplier_cost?: number | null;
  weight?: number | null;
  cost_price: number;
  avatar: string;
  categories?: (string | null)[] | null;
  variations?: (VariationInput | null)[] | null;
  combinations?: (ProductCombinationInput | null)[] | null;
  combination_string?: string | null;
  media: string[];
  tags?: (string | null)[] | null;
  shop_id?: string | null;
  catalog_id?: (string | null)[] | null;
  uuid: string;
  user_id?: string | null;
  supplier_id?: string | null;
  verified: boolean;
  extra_information?: string | null;
  distributionChannels?: (string | null)[] | null;
  minimumOrderQuantity?: number | null;
  product_origin?: ProductOrigin | null;
  productType?: ProductType | null;
  digitalDetails?: any | null;
  instantDelivery?: boolean | null;
  personnel?: string | null;
  reason?: string | null;
}

export interface productFilter {
  sku?: StringOperator | null;
  combination_string?: StringOperator | null;
  distributionChannels?: StringOperator | null;
  title?: StringOperator | null;
  price?: NumberOperator | null;
  id?: IdOperator | null;
  qty?: NumberOperator | null;
  transit_stock?: NumberOperator | null;
  main_stock?: NumberOperator | null;
  supplier_id?: IdOperator | null;
  reseller_id?: IdOperator | null;
  partner?: IdOperator | null;
  contractor?: IdOperator | null;
  shop?: ShopProductFilter | null;
  shopCollection?: ShopCollectionProductFilter | null;
  verified?: BooleanOperator | null;
  published?: BooleanOperator | null;
  status?: StringOperator | null;
  inhouse?: BooleanOperator | null;
  random?: boolean | null;
  catalog?: CatalogFilter | null;
  category?: ProductCategoryFilter | null;
  attended_to?: BooleanOperator | null;
  country?: StringOperator | null;
  tags?: StringOperator | null;
  uuid?: StringOperator | null;
  resell?: BooleanOperator | null;
  product_origin?: StringOperator | null;
  productType?: ProductType | null;
  instantDelivery?: BooleanOperator | null;
  paymentBeforeDelivery?: BooleanOperator | null;
}

export interface requestChangeSupplierPhoneInput {
  phone: string;
  newPhone: string;
}

export interface requestOTPInput {
  email?: string | null;
  phone?: string | null;
  channel?: ChannelType | null;
}

export interface tempCreateProductInput {
  id?: string | null;
  title: string;
  sku: string;
  qty?: number | null;
  description: string;
  limited_stock?: boolean | null;
  inhouse?: boolean | null;
  currency: CurrencyCode;
  country: CountryCode;
  published: boolean;
  status?: ProductStatus | null;
  price: number;
  weight?: number | null;
  cost_price: number;
  supplier_cost?: number | null;
  avatar: string;
  categories?: (TempCategoryInput | null)[] | null;
  variations?: (VariationInput | null)[] | null;
  combinations?: (ProductCombinationInput | null)[] | null;
  combination_string?: string | null;
  media: string[];
  tags?: (string | null)[] | null;
  catalog_id?: (string | null)[] | null;
  uuid: string;
  user_id?: string | null;
  supplier_id?: string | null;
  shop_id?: string | null;
  distributionChannels?: (string | null)[] | null;
  minimumOrderQuantity?: number | null;
  productType?: ProductType | null;
  product_origin?: ProductOrigin | null;
  instantDelivery?: boolean | null;
  digitalDetails?: any | null;
  minimumDeliveryTime?: number | null;
  maximumDeliveryTime?: number | null;
  shippingCost?: number | null;
  extra_information?: string | null;
  personnel?: string | null;
  reason?: string | null;
}

export interface verifySupplierOTPInput {
  medium: string;
  code: string;
  token: string;
  update?: boolean | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
